import React, { useState } from "react";
import "./login.scss";
import logo from "../../assets/images/logo.png";
import { login } from "../../api/crawlerApi";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage("Please enter username and password.");
      return;
    }

    try {
      setSubmitting(true);
      setErrorMessage("");
      await login(username, password);
      window.location.href = "/";
    } catch (error) {
      setErrorMessage(error.message || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <img className="login-page__logo" src={logo} alt="YKMW Group of Companies" />

        <h1 className="login-page__title">Welcome Back!</h1>
        <p className="login-page__subtitle">Please login to continue</p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon">👤</span>
            <input
              className="login-page__input"
              type="text"
              placeholder="Username"
              value={username}
              autoComplete="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon">🔒</span>
            <input
              className="login-page__input"
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit">
            {submitting ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;
